import "./index.css";
import React, { memo } from "react";
import { FaPlus, FaRegComment } from "react-icons/fa";
import { Handle } from "reactflow";

import { ValidatorFn } from "../../../helpers/validationConnector";
import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

const msgTypes = {
	media: "mídia",
	text: "texto",
	"media-url": "mídia (URL)",
};

export default memo(({ data, ...rest }) => {
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle
				type="target"
				position="left"
				isConnectable={true}
				isConnectableStart={false}
			/>

			<NodeHeader
				rest={rest}
				data={data}
				icon={<FaRegComment />}
				text={`Mensagem de ${msgTypes[data.msgType ?? "text"]}`}
			/>

			<div className="sendMessageContent">
				<div title={data.msgMessage}>{data.msgMessage}</div>
			</div>

			<Handle
				type="source"
				position="right"
				className="handle"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
		</>
	);
});
